import { Heading, Text } from 'ui-kit/typography'
import { UIDataType } from './uiData'
import { Link, Actions } from 'ui-kit/actions'
import clsx from 'clsx'
import classes from './IntegrationUXUI.module.scss'

export const IntegrationUXUICard = ({ card }: { card: UIDataType }) => {
  const {
    image,
    imageWidth,
    imageHeight,
    title,
    description,
    link1,
    link2,
    background,
  } = card

  return (
    <div className={clsx(classes.card, background && classes.card__bg)}>
      {background && (
        <img
          src={background.src}
          alt='background'
          className={classes.card_background}
        />
      )}

      <div className={classes.card_visual}>
        <img
          width={imageWidth}
          height={imageHeight}
          src={image.src}
          alt='UI Card'
        />
      </div>

      <div className={classes.card_content}>
        <Heading as={'h3'} size={'xs'} className={classes.card_title}>
          {title}
        </Heading>

        <Text size={'lg'} className={classes.card_description}>
          {description}
        </Text>

        {link1 && link2 && (
          <Actions className={classes.card_actions}>
            <Text as={'span'} size={'lg'} className={classes.card_actionsTitle}>
              Documentation:
            </Text>

            <Link
              className={classes.card_button}
              asPageButton
              type='secondary'
              href={link1.href}
            >
              {link1.value}
            </Link>

            <Link
              className={classes.card_button}
              asPageButton
              type='secondary'
              href={link2.href}
            >
              {link2.value}
            </Link>
          </Actions>
        )}
      </div>
    </div>
  )
}
